"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_CLONE_ERROR = exports.MESSAGE = exports.REJECTED = exports.FULFILLED = exports.REPLY = exports.CALL = exports.HANDSHAKE_REPLY = exports.HANDSHAKE = void 0;
const HANDSHAKE = 'handshake';
exports.HANDSHAKE = HANDSHAKE;
const HANDSHAKE_REPLY = 'handshake-reply';
exports.HANDSHAKE_REPLY = HANDSHAKE_REPLY;
const CALL = 'call';
exports.CALL = CALL;
const REPLY = 'reply';
exports.REPLY = REPLY;
const FULFILLED = 'fulfilled';
exports.FULFILLED = FULFILLED;
const REJECTED = 'rejected';
exports.REJECTED = REJECTED;
const MESSAGE = 'message';
exports.MESSAGE = MESSAGE;
const DATA_CLONE_ERROR = 'DataCloneError';
exports.DATA_CLONE_ERROR = DATA_CLONE_ERROR;